import { MEDIA_CONTENTS } from 'src/constants/mediaContent';

import MediaItem from './MediaItem';
import { Container, ScrollContainer } from './styled';

export default function MediaColumn() {
  return (
    <ScrollContainer>
      <Container>
        {MEDIA_CONTENTS.map((mediaContent, i) => (
          <MediaItem
            key={mediaContent.url}
            title={mediaContent.title}
            imgURL={mediaContent.imgURL}
            tag={mediaContent.tag}
            url={mediaContent.url}
            date={mediaContent.date}
            isNew={i === 0}
            playTime={mediaContent.playTime}
          />
        ))}
      </Container>
    </ScrollContainer>
  );
}
